import React, { useRef, useEffect } from "react";
import "./ProductDisplayWithDescription.css";
import { ProductCard } from "../../components/productCard/ProductCard.jsx";

const ProductDisplayWithDescription = (props) => {
  const { data = null, images, landScapeImg } = props;
  const itemRefs = useRef([]);

  useEffect(() => {
  const currentItemRefs = itemRefs.current; // snapshot for this effect run

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { threshold: 0.3 }
  );

  currentItemRefs.forEach((ref) => {
    if (ref) observer.observe(ref);
  });

  return () => {
    // use the same snapshot, not itemRefs.current
    currentItemRefs.forEach((ref) => {
      if (ref) observer.unobserve(ref);
    });
    observer.disconnect();
  };
}, []);


  return (
    <div className="displayContainer">
      <div
        className="intro fade-in"
        ref={(el) => (itemRefs.current[data?.length] = el)}
      >
        {data?.map((item, index) => {
          const isEven = index % 2 === 0;

          return (
            <>
              <section class="section-head-protection">
                <h2 class="section-heading">{item.title}</h2>
              </section>

              <p className="hero__subhead">{item.productDescription}</p>
              <div
                key={index}
                ref={(el) => (itemRefs.current[index] = el)}
                className={`row ${isEven ? "left" : "right"} fade-in`}
              >
                <div className="helmet-features">
                  <ul>
                    {item?.points?.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </>
          );
        })}
      </div>
      <div class="helmet-showcase">
        <div>
          {images &&
            images.length > 0 &&
            images.map((imgObj, index) => (
              <ProductCard
                title=" Protective clothing"
                img={imgObj.image}
                landScapeImg={landScapeImg}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default ProductDisplayWithDescription;
